export const SET_ALL_PAYMENTS = "my_wallet/SET_ALL_PAYMENTS"

export const CLEAR_ALL_PAYMENTS = "my_wallet/CLEAR_ALL_PAYMENTS"

export const SET_MONEY_VISIBILITY = "my_wallet/SET_MONEY_VISIBILITY"

export const SET_ALL_RESCUES_OPEN = "my_wallet/SET_ALL_RESCUES_OPEN"

export const SET_ALL_RESCUES_CLOSED = "my_wallet/SET_ALL_RESCUES_CLOSED"

export const SET_AVAILABLE_FOR_REDEMPTION = "my_wallet/SET_AVAILABLE_FOR_REDEMPTION"

export const SET_CREDITS_UNDER_REVIEW = "SET_CREDITS_UNDER_REVIEW"

export const SET_CREDITS_RESCUED_DETAILS = "my_wallet/SET_CREDITS_RESCUED_DETAILS"

export const SET_TYPE_OF_SERVICES_ALLOWED = "my_wallet/SET_TYPE_OF_SERVICES_ALLOWED"

export const SET_LAST_PAGE_OF_PAGINATION = "my_wallet/SET_LAST_PAGE_OF_PAGINATION"

export const SET_CURRENT_PAGE_OF_PAGINATION = "my_wallet/SET_CURRENT_PAGE_OF_PAGINATION"

export const SET_PAGES_ALREADY_LOADED = "my_wallet/SET_PAGES_ALREADY_LOADED"

export const SET_CURRENT_KEY_REFRESH_COMPONENTS = "my_wallet/SET_CURRENT_KEY_REFRESH_COMPONENTS"

export const SET_SERVICES_LOADED_IN_INDEX = "my_wallet/SET_SERVICES_LOADED_IN_INDEX"
